var swiperFreeMode = new Swiper(".swiper-free-mode", {
    slidesPerView: 1.2,
    spaceBetween: 20,
    freeMode: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
});

var pagingSwiper = new Swiper(".swiper-points", {
	slidesPerView: 3,
	spaceBetween: 0,
	slidesPerGroup: 1,
	loop: false,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
});
var pointsSwiper = new Swiper('.swiper-points', {
	slidesPerView: 3,
	spaceBetween: 0,
    loop: false,
    a11y: {
      enabled: true,
      slideLabelMessage: ""
    },
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
  });
  
  pointsSwiper.controller.control = pagingSwiper;
  pagingSwiper.controller.control = pointsSwiper;

  var mobPagingSwiper = new Swiper(".swiper-dots-mob", {
	slidesPerView: 1,
	spaceBetween: 0,
	loop: false,
	pagination: {
		el: ".swiper-dots-mob .swiper-pagination-fraction",
		type: "fraction",
	},
});
var mobPointsSwiper = new Swiper('.swiper-dots-mob', {
	slidesPerView: 1,
	spaceBetween: 0,
    loop: false,
    a11y: {
      enabled: true,
      slideLabelMessage: ""
    },
	pagination: {
        el: ".swiper-dots-mob .swiper-pagination",
		clickable: true
    },
  });
  
  mobPointsSwiper.controller.control = mobPagingSwiper;
  mobPagingSwiper.controller.control = mobPointsSwiper;

  var signatureSwiper = new Swiper('.swiper-signature', {
	slidesPerView: 1,
	spaceBetween: 0,
    loop: false,
    a11y: {
      enabled: true,
      slideLabelMessage: ""
    },
	pagination: {
        el: ".swiper-signature .swiper-pagination",
		clickable: true
    },
  });

  var swiper = new Swiper('.item-image .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow:true,
    navigation: {
      nextEl: '.item-image .swiper-button-next',
      prevEl: '.item-image .swiper-button-prev',
    }
  });

  var swiper = new Swiper('.prize-section', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    a11y: {
      enabled: true,
      slideLabelMessage: ""
    },
    navigation: {
        nextEl: '.prize-section .swiper-button-next',
        prevEl: '.prize-section .swiper-button-prev',
    }
  });
  
// Tab
const swiperTab = new Swiper('.tab-navigation .swiper-container', {
	slidesPerView: 4,
	loop: true,
	allowTouchMove: false,
	lazyPreloadPrevNext: 3,
	a11y: {
		enabled: false,
		slideRole: '',
		slideLabelMessage: ''
	},
	navigation: {
		nextEl: '.hp-journey .swiper-button-next',
		prevEl: '.hp-journey .swiper-button-prev',
	},
})

const swiperTabContent = new Swiper('.tab-content .swiper-container', {
	slidesPerView: 1,
	loop: true,
	lazyPreloadPrevNext: 3,
	navigation: {
		nextEl: '.hp-journey .swiper-button-next',
		prevEl: '.hp-journey .swiper-button-prev',
	},
	on: {
		// Triggered on each slide change
		slideChange: function () {
			// Cache the journey container, tab links wrapper, and panels wrapper
			const $journey = $('.hp-journey')
			const $tabLinksWrap = $journey.find('#journey-tabs')
			const $panelsWrapper = $journey.find('#journey-panels')

			// Get the IDs of the currently active tab and panel
			const $currentActiveTab = $tabLinksWrap.find('.active').prop('id')
			const $currentActivePanel = $panelsWrapper.find('.swiper-slide-active').prop('id')

			// Find the first anchor within the currently active panel and set its tabindex to -1
			const currentAnchor = $(`#${$currentActivePanel} a:first-child`)
			currentAnchor.attr('tabindex', '-1')

			// Remove active classes from the currently active tab and set attributes accordingly
			$(`#${$currentActiveTab}`).removeClass('tab-active swiper-slide-active active').attr({
				'tabindex': '-1',
				'aria-selected': 'false',
				'aria-hidden': 'true'
			})
		},

		// Triggered at the end of the slide change transition
		slideChangeTransitionEnd: function () {
			// Cache the journey container and panels wrapper
			const $journey = $('.hp-journey')
			const $panelsWrapper = $journey.find('#journey-panels')

			// Get the ID of the currently active panel and derive the corresponding tab ID
			const $currentActivePanel = $panelsWrapper.find('.swiper-slide-active').prop('id')
			const $currentActiveTab = $currentActivePanel.replace('panel', 'tab')

			// Find the first anchor within the currently active panel and set its tabindex to 0
			const currentAnchor = $(`#${$currentActivePanel} a:first-child`)
			currentAnchor.attr('tabindex', '0')

			// Add active classes to the currently active tab and set attributes accordingly
			$(`#${$currentActiveTab}`).addClass('tab-active swiper-slide-active active').attr({
				'tabindex': '0',
				'aria-selected': 'true',
				'aria-hidden': 'false'
			})
		}
	}
})

const tabItems = document.querySelectorAll('.tab-navigation .swiper-slide')
tabItems.forEach((link, index) => {
	link.addEventListener('click', () => {
		tabItems.forEach(link => link.classList.remove('tab-active'))
		link.classList.add('tab-active')
		swiperTabContent.slideTo(index)
	})
})

